import template from './users.html';
import './users.scss';

export class UsersController {

}

export default {
  controller: UsersController,
  template,
  transclude: {
    menu: 'usersMenu',
    list: 'usersList',
    content: 'usersContent',
  },
};
